type TSendResizeMessageOptions = {
  type: string;
  meta?: Record<string, unknown>;
  payload?: {
    frame?: {
      style?: Partial<CSSStyleDeclaration>;
    };
  };
};

function sendResizeMessage({ type, meta, payload }: TSendResizeMessageOptions): void {
  const message = {
    type,
    meta,
    payload,
  };
  window.parent.postMessage(message, '*');
}

export { sendResizeMessage };
